import React, { useEffect, useMemo, useState } from 'react'
import { DRAWER_TYPES, strings } from '@constants'
import { PageLevelTableWrapper } from '@base'
import { Table, TableActionButton, TableColumns } from '@baseV2'
import { useDispatch } from 'react-redux'
import { toggleDrawer } from '@data/state/action/root'
import { getDataCorrectionList } from '@data'
import { showLoader } from '@data/state/action'
import { displayAmount } from '@utils'
import { Text } from '@styles'
import styled from 'styled-components'
import { OpenInNew } from '@material-ui/icons'

const MenuIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	& > svg {
		font-size: ${Text.LARGE};
	}
`

const Ledger = ({ update, forceUpdate }) => {
	const dispatch = useDispatch()
	const [data, setData] = useState([])

	useEffect(() => {
		dispatch(showLoader(true))
		getDataCorrectionList()
			.then((res) => {
				setData(res)
			})
			.catch((err) => console.log(err))
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [forceUpdate])

	const columns = useMemo(
		() => [
			{
				label: strings('transaction', 'id'),
				key: 'transaction_id',
				mobile: true,
				sortable: false,
			},
			{
				label: strings('document', 'number'),
				key: 'original_document_number',
				mobile: true,
				sortable: false,
			},
			{
				label: strings('organisation'),
				key: 'organisation_name',
				sortable: false,
			},
			TableColumns.dateColumn({
				align: 'left',
				key: 'transaction_date',
				label: strings('date'),
				sortable: false,
			}),

			{
				label: strings('amount'),
				key: (item) => {
					return <>{displayAmount(item?.transaction_amount, { default: 0 })}</>
				},
				sortable: false,
			},
			{
				label: strings('trading_expense'),
				key: 'trading_expense',
				sortable: false,
			},
			{
				label: strings('source'),
				key: 'source',
				sortable: false,
			},
			TableColumns.actionsColumn({
				align: 'center',
				label: strings('zoho', 'link'),
				renderer: (row) => {
					return (
						<TableActionButton small uppercase onClick={manageClickHandler(row)}>
							<MenuIcon>
								<OpenInNew />
							</MenuIcon>
						</TableActionButton>
					)
				},
				mobile: false,
			}),
		],
		[]
	)

	const manageClickHandler = (row) => (e) => {
		e.stopPropagation()
		row?.zoho_link && window.open(row?.zoho_link, '_blank')
	}

	const rowClickHandler = (row) => {
		dispatch(
			toggleDrawer(true, DRAWER_TYPES.DATA_CORRECTION_TRADING_EXPENSE, {
				label: strings('edit', 'trading_expense'),
				data: row,
				update: update,
			})
		)
	}

	return (
		<PageLevelTableWrapper>
			<Table
				page={0}
				fullHeight
				data={data}
				columns={columns}
				rowsToDisplay={data?.length}
				totalItemCount={data?.length}
				rowClickable={true}
				onRowClick={rowClickHandler}
			/>
		</PageLevelTableWrapper>
	)
}

export default Ledger
